/* VTB My Garage + smart search routing (2026-10-14, round 7).
   - Garage chip in the header (saved bike in localStorage "vtb_my_bike_v1", same key the YMM pickers use).
   - Search routing: model + part words -> our curated collection pages (suggestion, never a forced redirect).
   - Collection and search pages: "only parts that fit my bike" toggles (client side, default view unchanged).
   - Search page: sold-out items hidden by default with a "Show out of stock" switch.
   Route data comes from window.VTB_ROUTES = { handle: [title, product_count] } (snippets/vtb-garage.liquid). */
(function () {
  'use strict';
  var KEY = 'vtb_my_bike_v1', FKEY = 'vtb_fit_only_v1';
  var CFG = window.VTB_GARAGE_CFG || {};
  var R = window.VTB_ROUTES || {};

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function getBike() { try { var b = JSON.parse(localStorage.getItem(KEY) || 'null'); return b && b.year && b.sub ? b : null; } catch (e) { return null; } }
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
  function short(b) { return b.year + ' ' + String(b.sub || b.model || '').replace(/^[A-Z0-9\/-]{2,}\s+(?=\S)/, ''); }
  function code(b) { var m = String(b.sub || '').match(/^([A-Z0-9\/-]{2,})\s+\S/); return m ? m[1] : ''; }
  function handleize(s) { return String(s).toLowerCase().replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }

  /* ───────────── 1. SEARCH ROUTING ───────────── */
  var MODELS = [
    { k: 'low-rider-st', n: 'Low Rider ST', re: /\b(low\s*rider\s*st|fxlrst|lrst)\b/ },
    { k: 'low-rider', n: 'Low Rider', re: /\blow\s*rider\b/ },
    { k: 'road-glide', n: 'Road Glide', re: /\b(road\s*glides?|fltrxs?e?|fltrk|fltr|rg)\b/ },
    { k: 'street-glide', n: 'Street Glide', re: /\b(street\s*glides?|flhxs?e?|flhx|sg)\b/ },
    { k: 'road-king', n: 'Road King', re: /\b(road\s*kings?|flhrc?|flhrxs?|flhrse|flhr)\b/ },
    { k: 'electra-glide', n: 'Electra Glide', re: /\b(electra\s*glides?|flht\w*)\b/ },
    { k: 'fat-bob', n: 'Fat Bob', re: /\b(fat\s*bobs?|fxfbs?)\b/ },
    { k: 'street-bob', n: 'Street Bob', re: /\b(street\s*bobs?|fxbbs?)\b/ },
    { k: 'fat-boy', n: 'Fat Boy', re: /\b(fat\s*boys?|flfbs?)\b/ },
    { k: 'heritage-classic', n: 'Heritage Classic', re: /\b(heritage(\s*classic)?|flhc\w*)\b/ },
    { k: 'breakout', n: 'Breakout', re: /\b(breakouts?|fxbrs?)\b/ },
    { k: 'softail', n: 'Softail', re: /\bsoftails?\b/ },
    { k: 'dyna', n: 'Dyna', re: /\bdynas?\b/ },
    { k: 'sportster', n: 'Sportster', re: /\bsportsters?\b/ },
    { k: 'pan-america', n: 'Pan America', re: /\b(pan\s*america|ra1250s?)\b/ },
    { k: 'indian-chieftain', n: 'Indian Chieftain', re: /\bchieftains?\b/ },
    { k: 'indian-challenger', n: 'Indian Challenger', re: /\bchallengers?\b/ },
    { k: 'touring', n: 'Touring', re: /\b(touring|baggers?)\b/ }
  ];
  var PARTS = [
    { k: 'exhaust', n: 'Exhaust', re: /\b(exhausts?|pipes?|mufflers?|muffs?|slip\s*-?ons?|headers?|headpipes?)\b/ },
    { k: 'suspension', n: 'Suspension', re: /\b(suspension|shocks?|forks?|lowering\s*kits?)\b/ },
    { k: 'brakes', n: 'Brakes', re: /\b(brakes?|rotors?|calipers?|brake\s*pads?)\b/ },
    { k: 'handlebars', n: 'Handlebars', re: /\b(handle\s*bars?|risers?|apes?|ape\s*hangers?|bars?)\b/, not: /\b(crash|sissy|luggage|tow|shield|engine\s*guard)\b/ },
    { k: 'controls', n: 'Controls', re: /\b(controls?|foot\s*pegs?|pegs?|floor\s*boards?|foot\s*boards?|floorboards?|footboards?)\b/ },
    { k: 'air-cleaners', n: 'Air Cleaners', re: /\b(air\s*cleaners?|air\s*filters?|intakes?)\b/ },
    { k: 'seats', n: 'Seats', re: /\b(seats?|saddles?(?!\s*bags?))\b/ }
  ];
  var BRANDS = [
    { k: 'vance-hines', n: 'Vance & Hines', re: /\b(vance\s*(and\s*)?hines|v\s*and\s*h|vandh|vh)\b/ },
    { k: 'kuryakyn', n: 'Kuryakyn', re: /\bkuryakyn\b/ },
    { k: 'cobra', n: 'Cobra', re: /\bcobra\b/ },
    { k: 'ss', n: 'S&S Cycle', re: /\b(s\s*and\s*s(\s*cycle)?|ss\s*cycle|ss)\b/ },
    { k: 'mustang', n: 'Mustang', re: /\bmustang\b/ },
    { k: 'ohlins', n: 'Ohlins', re: /\bohlins?\b/ },
    { k: 'progressive', n: 'Progressive Suspension', re: /\bprogressive\b/ },
    { k: 'performance-machine', n: 'Performance Machine', re: /\b(performance\s*machine|pm)\b/ },
    { k: 'dynojet', n: 'Dynojet', re: /\bdyno\s*jet\b/ },
    { k: 'feuling', n: 'Feuling', re: /\bfeuling\b/ },
    { k: 'cometic', n: 'Cometic', re: /\bcometic\b/ },
    { k: 'goodridge', n: 'Goodridge', re: /\bgoodridge\b/ },
    { k: 'avon', n: 'Avon', re: /\bavon\b/ },
    { k: 'kpmi', n: 'KPMI', re: /\bkpmi\b/ },
    { k: 'fox', n: 'Fox', re: /\bfox\b/ },
    { k: 'ebc', n: 'EBC', re: /\bebc\b/ },
    { k: 'hawg-halters', n: 'Hawg Halters', re: /\bhawg\s*halters?\b/ },
    { k: 'harddrive', n: 'Harddrive', re: /\bhard\s*drive\b/ },
    { k: 'burly-brand', n: 'Burly Brand', re: /\bburly(\s*brand)?\b/ },
    { k: 'danny-gray', n: 'Danny Gray', re: /\bdanny\s*gray\b/ },
    { k: 'flo-motorsports', n: 'Flo Motorsports', re: /\bflo(\s*motorsports?)?\b/ },
    { k: 'lyndall-brakes', n: 'Lyndall Brakes', re: /\blyndall(\s*brakes?)?\b/ },
    { k: 'santoro-fabworx', n: 'Santoro Fabworx', re: /\bsantoro(\s*fabworx)?\b/ },
    { k: 'baggernation', n: 'Baggernation', re: /\bbagger\s*nation\b|\bbaggernation\b/ }
  ];
  function normQ(q) {
    var s = String(q || '').toLowerCase();
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
    s = s.replace(/&/g, ' and ').replace(/\b(?:19|20)\d\d\b/g, ' ').replace(/[^a-z0-9\s-]/g, ' ').replace(/\s+/g, ' ').trim();
    return s;
  }
  function firstMatch(list, s) {
    var best = null;
    list.forEach(function (it) {
      if (it.not && it.not.test(s)) return;
      var m = s.match(it.re);
      if (m && (!best || m.index < best.m.index || (m.index === best.m.index && m[0].length > best.m[0].length))) best = { it: it, m: m };
    });
    return best;
  }
  function cnt(n) { return n + ' part' + (n === 1 ? '' : 's'); }
  function route(q) {
    var s = normQ(q); if (s.length < 3 || /king of the baggers|\bkotb\b/.test(s)) return null;
    var mm = firstMatch(MODELS, s); if (!mm) return null;
    var model = mm.it;
    var rest = (s.slice(0, mm.m.index) + ' ' + s.slice(mm.m.index + mm.m[0].length)).replace(/\s+/g, ' ');
    var bm = firstMatch(BRANDS, rest), brand = bm && bm.it;
    var restNoBrand = bm ? (rest.slice(0, bm.m.index) + ' ' + rest.slice(bm.m.index + bm.m[0].length)) : rest;
    var pm = firstMatch(PARTS, restNoBrand), part = pm && pm.it;
    var h, label;
    if (brand) {
      h = brand.k + '-' + model.k;
      if (R[h]) return { h: h, url: '/collections/' + h, label: brand.n + ' for ' + model.n, count: R[h][1] };
    }
    if (part) {
      h = model.k + '-' + part.k;
      if (R[h]) return { h: h, url: '/collections/' + h, label: model.n + ' ' + part.n, count: R[h][1] };
    }
    h = model.k + '-parts';
    if (R[h]) return { h: h, url: '/collections/' + h, label: model.n + ' Parts', count: R[h][1] };
    return null;
  }
  function routeHtml(r, cls) {
    return '<a class="vtb-route ' + (cls || '') + '" href="' + esc(r.url) + '">' +
      '<span class="vtb-route__k">Our hand-picked page</span>' +
      '<span class="vtb-route__t">' + esc(r.label) + ' &mdash; ' + esc(cnt(r.count)) + ' &rarr;</span></a>';
  }

  /* predictive search suggestion: separate container above the live results */
  function wirePredictive() {
    var input = $('#sp-input'), live = $('#sp-live'); if (!input || !live) return;
    var box = $('#vtb-sp-route');
    if (!box) { box = document.createElement('div'); box.id = 'vtb-sp-route'; live.parentNode.insertBefore(box, live); }
    function update() {
      var r = route(input.value);
      box.innerHTML = r ? routeHtml(r, 'vtb-route--sp') : '';
    }
    input.addEventListener('input', update);
    var clr = $('#sp-clear'); if (clr) clr.addEventListener('click', function () { box.innerHTML = ''; });
    $$('.sp-tag').forEach(function (t) { t.addEventListener('click', function () { setTimeout(update, 0); }); });
    /* "Road Glide Exhaust" is also one of the popular-search tags */
  }

  /* search page banner */
  function wireSearchBanner() {
    var slot = $('#vtb-route-slot'); if (!slot) return;
    var p = new URLSearchParams(location.search);
    var r = route(p.get('vtb_oq') || p.get('original') || p.get('q') || '') || route(p.get('q') || '');
    if (!r) return;
    slot.innerHTML = '<div class="vtb-routebar">' +
      '<div class="vtb-routebar__lead">Looking for ' + esc(r.label) + '? Start here:</div>' +
      routeHtml(r, 'vtb-route--big') + '</div>';
    slot.hidden = false;
  }

  /* ───────────── 2. MY VTWINBIKE: CHIP + PICKER OVERLAY ───────────── */
  var lastFocus = null, dlg = null, trigger = null, st = null;
  var POPULAR = ['Road Glide', 'Street Glide', 'Road King', 'Low Rider', 'Fat Bob', 'Street Bob', 'Softail Slim', 'Fat Boy', 'Heritage Classic', 'Electra Glide / Ultra', 'Breakout', 'Sport Glide', 'Chieftain', 'Challenger', 'Roadmaster', 'Springfield', 'Scout'];
  var MAKE_W = { 'Harley-Davidson': ['HARLEY-DAVIDSON', 'Motor Company'], 'Indian Motorcycle': ['INDIAN', 'Motorcycle'] };
  var ICO = function (n, s) { return window.VTB_ICO ? window.VTB_ICO(n, s) : ''; };
  function paintChips() {
    var b = getBike();
    try { document.documentElement.classList.toggle('vtb-has', !!b); } catch (e) {}
    $$('[data-vtb-garage]').forEach(function (el) {
      var t = el.querySelector('.vtb-gc__txt'); if (t) t.textContent = b ? short(b) : 'PICK MY VTWIN MOTORCYCLE';
      var k = el.querySelector('.vtb-gc__k'); if (k) k.hidden = !b;
      var g = el.querySelector('.vtb-gc__go'); if (g) g.textContent = b ? 'Change' : '';
      el.setAttribute('aria-label', b ? 'MY VTWINBIKE: ' + short(b) + '. Change or remove your motorcycle.' : 'Pick my VTWIN motorcycle');
    });
    paintHome();
  }
  /* home hero panel: saved-bike card instead of empty selector */
  function paintHome() {
    var b = getBike(), Y = ymm();
    $$('[data-vtb-home]').forEach(function (p) {
      var a = $('[data-vtb-home-empty]', p), c = $('[data-vtb-home-saved]', p);
      if (a) a.hidden = !!b; if (c) c.hidden = !b;
      if (b && c) {
        var n = $('[data-vtb-home-name]', c); if (n) n.textContent = short(b);
        var s = $('[data-vtb-home-shop]', c);
        if (s) s.href = Y && Y.bikeUrl ? Y.bikeUrl(b) : '/collections/all/' + handleize(b.year + ' ' + b.make + ' ' + b.sub);
      }
    });
  }
  function loadYmm(cb) {
    if (window.VTB && window.VTB.ymm && window.VTB.ymm.yearsFor) return cb();
    if (document.querySelector('script[data-vtb-ymm-load]')) { document.querySelector('script[data-vtb-ymm-load]').addEventListener('load', function () { cb(); }); return; }
    var s = document.createElement('script'); s.src = CFG.ymmSrc; s.setAttribute('data-vtb-ymm-load', '1');
    s.onload = function () { cb(); }; s.onerror = function () { cb(true); };
    document.head.appendChild(s);
  }
  function ymm() { return window.VTB && window.VTB.ymm; }
  function closeDlg() {
    if (!dlg) return;
    dlg.parentNode.removeChild(dlg); dlg = null; st = null;
    document.removeEventListener('keydown', onKey, true);
    document.body.classList.remove('vtb-dlg-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  function focusables() { return $$('button:not([disabled]),input,select:not([disabled]),a[href],[tabindex="0"]', dlg).filter(function (el) { return el.offsetParent !== null || el === document.activeElement; }); }
  function onKey(e) {
    if (!dlg) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closeDlg(); return; }
    if (e.key === 'Tab') {
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1], a = document.activeElement;
      if (!dlg.contains(a)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    }
  }
  function place() {
    if (!dlg) return;
    var panel = $('.vtb-pk__panel', dlg);
    if (window.innerWidth >= 900) {
      var hd = document.querySelector('.site-header'), hb = hd ? hd.getBoundingClientRect().bottom : 0;
      var w = Math.min(640, window.innerWidth - 32);
      var top = Math.max(64, Math.min(hb > 0 ? hb + 6 : 72, 140));
      var left = Math.max(16, window.innerWidth - w - Math.max(16, (window.innerWidth - 1280) / 2 + 24));
      panel.style.cssText = 'top:' + top + 'px;left:' + left + 'px;width:' + w + 'px;max-height:' + (window.innerHeight - top - 16) + 'px';
    } else panel.style.cssText = '';
  }
  function openDlg(forceChange, trig) {
    lastFocus = document.activeElement; trigger = trig || lastFocus;
    if (dlg) closeDlg();
    dlg = document.createElement('div'); dlg.className = 'vtb-pk';
    /* critical positioning inline so it is an overlay even if a stylesheet fails to load */
    dlg.style.cssText = 'position:fixed;top:0;right:0;bottom:0;left:0;z-index:2147483000';
    dlg.innerHTML = '<div class="vtb-pk__bg" data-x style="position:absolute;top:0;right:0;bottom:0;left:0"></div>' +
      '<div class="vtb-pk__panel" role="dialog" aria-modal="true" aria-labelledby="vtb-pk-h" tabindex="-1">' +
      '<div class="vtb-pk__top">' + ICO('motorcycle', 26) + '<h2 id="vtb-pk-h" class="vtb-pk__h"></h2>' +
      '<button type="button" class="vtb-pk__x" data-x aria-label="Close">' + ICO('close', 22) + '</button></div>' +
      '<div class="vtb-pk__dots" id="vtb-pk-dots" aria-hidden="true"></div>' +
      '<div class="vtb-pk__body" id="vtb-pk-body"></div><div class="vtb-pk__foot" id="vtb-pk-foot" hidden></div></div>';
    /* append to <html> so no transformed ancestor in <body> can break position:fixed */
    document.documentElement.appendChild(dlg);
    document.body.classList.add('vtb-dlg-open');
    var sw = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden';
    if (sw > 0) document.body.style.paddingRight = sw + 'px';
    dlg.addEventListener('click', function (e) { if (e.target.hasAttribute('data-x') || (e.target.closest && e.target.closest('[data-x]'))) closeDlg(); });
    document.addEventListener('keydown', onKey, true);
    place();
    setTitle(false);
    renderDlg(!!forceChange);
    var panel = $('.vtb-pk__panel', dlg); if (panel) panel.focus({ preventScroll: true });
  }
  window.addEventListener('resize', place);
  function renderDlg(change, justSaved) {
    var body = $('#vtb-pk-body'), foot = $('#vtb-pk-foot'), dots = $('#vtb-pk-dots'); if (!body) return;
    var b = getBike(), Y = ymm();
    if (b && !change) {
      dots.hidden = true; foot.hidden = true; setTitle(true);
      var shop = Y && Y.bikeUrl ? Y.bikeUrl(b) : '/collections/all/' + handleize(b.year + ' ' + b.make + ' ' + b.sub);
      body.innerHTML = '<div class="vtb-card">' + (justSaved ? '<p class="vtb-card__ok">' + ICO('check', 16) + ' Saved to MY VTWINBIKE</p>' : '<p class="vtb-card__k">Your motorcycle</p>') +
        '<p class="vtb-card__bike">' + esc(short(b)) + '</p><p class="vtb-card__sub">' + esc(b.make + (code(b) ? ' ' + code(b) : '')) + '</p></div>' +
        '<a class="vtb-btn vtb-btn--go" id="vtb-shop-bike" href="' + esc(shop) + '">Shop parts for this motorcycle</a>' +
        '<div class="vtb-card__row"><button type="button" class="vtb-btn" data-act="change">Change motorcycle</button>' +
        '<button type="button" class="vtb-btn vtb-btn--quiet" data-act="clear">Remove motorcycle</button></div>';
      if (!Y || !Y.bikeUrl) loadYmm(function () { var a = $('#vtb-shop-bike'); if (a && ymm() && ymm().bikeUrl && getBike()) a.href = ymm().bikeUrl(getBike()); });
      body.querySelector('[data-act="change"]').addEventListener('click', function () { renderDlg(true); });
      body.querySelector('[data-act="clear"]').addEventListener('click', function () { lsSet(KEY, null); lsSet(FKEY, null); fire(); renderDlg(false); });
      var f = body.querySelector('#vtb-shop-bike'); if (f) f.focus();
      return;
    }
    dots.hidden = true; foot.hidden = true; setTitle(false);
    body.innerHTML = '<div data-vtb-dlgmount></div>';
    mountPicker($('[data-vtb-dlgmount]', body), { focus: true, done: function (nb) {
      var stay = !!document.querySelector('[data-vtb-fitrow],#vtb-fitb');
      if (stay) { renderDlg(false, true); } else { var Y2 = ymm(); window.location.href = Y2.bikeUrl(nb); }
    } });
  }
  function setTitle(saved) {
    var h = $('#vtb-pk-h', dlg); if (!h) return;
    h.innerHTML = saved ? 'MY VTWINBIKE<small>Your saved motorcycle. We show only parts that fit.</small>' : 'PICK MY VTWIN MOTORCYCLE<small>Tell us your motorcycle. We show only parts that fit.</small>';
  }
  /* ───── Shared picker: four native <select>s (Year, Make, Model, Exact model). On phones the OS scroll wheel opens. ───── */
  var psUid = 0;
  function mountPicker(el, o) {
    o = o || {};
    if (!el || el.__vtbM) return; el.__vtbM = 1;
    loadYmm(function (err) { var Y = ymm(); if (err || !Y || !Y.yearsFor) { el.__vtbM = 0; if (o.focus) el.innerHTML = '<p class="vtb-pk__msg" role="alert">Sorry, the motorcycle list did not load. Please close this and try again.</p>'; return; } build(Y); });
    function build(Y) {
      var id = 'vtb-ps' + (++psUid), cur = getBike();
      var F = [['year', 'Year', 'Select year'], ['make', 'Make', 'Select make'], ['model', 'Model', 'Select model'], ['sub', 'Exact model', 'Select exact model']];
      el.innerHTML = '<form class="vtb-ps' + (o.dark ? ' vtb-ps--dark' : '') + (o.row ? ' vtb-ps--row' : '') + '" novalidate aria-label="Pick my VTWIN motorcycle">' +
        F.map(function (x) { return '<div class="vtb-ps__f"><label for="' + id + x[0] + '">' + x[1] + '</label><select id="' + id + x[0] + '" data-k="' + x[0] + '"></select>' + ICO('chev', 16) + '</div>'; }).join('') +
        '<button type="submit" class="vtb-btn vtb-btn--go vtb-ps__go" disabled>' + (o.cta || 'SHOW PARTS THAT FIT') + '</button></form>';
      var form = $('form', el), sel = {}, go = $('.vtb-ps__go', el);
      F.forEach(function (x) { sel[x[0]] = $('[data-k="' + x[0] + '"]', el); });
      function opt(v, l, on) { return '<option value="' + esc(v) + '"' + (on ? ' selected' : '') + '>' + esc(l) + '</option>'; }
      function fill(k, items, want, ph, groups) {
        var s = sel[k], ok = items.some(function (i) { return i.v === want; });
        var val = ok ? want : (k !== 'year' && k !== 'model' && items.length === 1 ? items[0].v : '');
        var h = opt('', ph, !val);
        if (groups) { groups.forEach(function (g) { if (g.items.length) h += (g.name ? '<optgroup label="' + esc(g.name) + '">' : '') + g.items.map(function (i) { return opt(i.v, i.l, i.v === val); }).join('') + (g.name ? '</optgroup>' : ''); }); }
        else h += items.map(function (i) { return opt(i.v, i.l, i.v === val); }).join('');
        s.innerHTML = h; s.disabled = !items.length; s.value = val;
        return val;
      }
      function sync(want) {
        var y = fill('year', Y.yearsFor().map(function (n) { return { v: String(n), l: String(n) }; }), want.year, 'Select year');
        var mk = y ? Y.makesFor(y).map(function (m) { return { v: m, l: m === 'Indian Motorcycle' ? 'Indian' : m }; }) : [];
        var m = fill('make', mk, want.make, y ? 'Select make' : 'Pick the year first');
        var fams = m ? Y.familiesFor(y, m) : [], pop = [], rest = [];
        fams.forEach(function (f) { (POPULAR.indexOf(f) !== -1 ? pop : rest).push(f); });
        pop.sort(function (a, b) { return POPULAR.indexOf(a) - POPULAR.indexOf(b); });
        var gi = function (a) { return a.map(function (f) { return { v: f, l: f }; }); };
        var f = fill('model', gi(fams), want.model, m ? 'Select model' : 'Pick the make first', pop.length && rest.length ? [{ name: 'Popular', items: gi(pop) }, { name: 'All models', items: gi(rest) }] : null);
        var subs = f ? Y.subsFor(y, m, f).map(function (x) { return { v: x.value, l: x.label }; }) : [];
        var sb = fill('sub', subs, want.sub, f ? 'Select exact model' : 'Pick the model first');
        go.disabled = !(y && m && f && sb);
        return { year: y, make: m, model: f, sub: sb };
      }
      var vals = sync(cur ? { year: String(cur.year), make: cur.make, model: cur.model, sub: cur.sub } : {});
      form.addEventListener('change', function (e) {
        var want = {};
        ['year', 'make', 'model', 'sub'].forEach(function (n) { want[n] = sel[n].value; });
        vals = sync(want);
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (go.disabled) return;
        var b = { year: +vals.year, make: vals.make, model: vals.model, sub: vals.sub };
        Y.setBike(b);
        if (o.done) o.done(b);
      });
      if (o.focus) { try { sel.year.focus({ preventScroll: true }); } catch (e) {} }
    }
  }
  function mountAll() { $$('[data-vtb-mount]').forEach(function (el) { var v = el.getAttribute('data-vtb-mount'); mountPicker(el, { dark: v === 'dark', row: v === 'dark-row', cta: el.getAttribute('data-cta') || '', done: function (b) { if (v === 'dark' || v === 'dark-row') { var Y = ymm(); window.location.href = Y.bikeUrl(b); } } }); }); }
  function saveBike() {}
  function fire() { try { window.dispatchEvent(new CustomEvent('vtb:bike')); } catch (e) { onBikeChange(); } }
  function wireChips() {
    document.addEventListener('click', function (e) {
      var el = e.target.closest ? e.target.closest('[data-vtb-garage],[data-vtb-open]') : null;
      if (!el) return;
      e.preventDefault();
      openDlg(!getBike() || el.hasAttribute('data-vtb-open') && el.getAttribute('data-vtb-open') === 'change', el);
    });
    var clr = $$('[data-vtb-clear]'); clr.forEach(function (el) { el.addEventListener('click', function () { lsSet(KEY, null); lsSet(FKEY, null); fire(); }); });
    paintChips();
  }

  /* ───────────── 3. FIT TOGGLES (collection + search) ───────────── */
  function cardFit(card, b) {
    var ft = card.getAttribute('data-vtb-fit');
    var key = b.year + ' ' + (b.make === 'Indian Motorcycle' ? 'IM ' : '') + b.sub;
    if (ft && ft.indexOf('|' + key + '|') !== -1) return 'yes';
    var fx = card.getAttribute('data-vtb-fx');
    if (fx) {
      var sk = '|' + (b.make === 'Indian Motorcycle' ? 'IM ' : '') + b.sub + '=', i = fx.indexOf(sk);
      if (i !== -1) { var ys = fx.slice(i + sk.length, fx.indexOf('|', i + 1)).split('.'); if (ys.indexOf(String(b.year)) !== -1) return 'yes'; }
      return 'no';
    }
    if (ft) return 'no';
    var ys = +card.getAttribute('data-fitment-year-start'), ye = +card.getAttribute('data-fitment-year-end') || ys;
    var mk = (card.getAttribute('data-fitment-make') || '').toLowerCase().split(/[\s-]/)[0], md = (card.getAttribute('data-fitment-model') || '').toLowerCase();
    if (!ys || !mk) return 'unknown';
    if (!(b.year >= ys && b.year <= ye && String(b.make).toLowerCase().indexOf(mk) === 0)) return 'no';
    if (!md) return 'unknown';
    return md.indexOf(String(b.model).toLowerCase()) !== -1 ? 'yes' : 'no';
  }
  function setSwitch(btn, on) { btn.setAttribute('aria-checked', on ? 'true' : 'false'); btn.classList.toggle('is-on', !!on); }
  function applyFilters() {
    var cards = $$('.coll-grid .product-card'); if (!cards.length) return;
    var b = getBike();
    var fitSw = $('[data-vtb-sw="fit"]'), oosSw = $('[data-vtb-sw="oos"]');
    var fitOn = !!(b && fitSw && fitSw.getAttribute('aria-checked') === 'true');
    var oosOn = !!(oosSw && oosSw.getAttribute('aria-checked') === 'true');
    var hideOos = !!oosSw && !oosOn;
    var allOos = hideOos && cards.every(function (c) { return c.getAttribute('data-avail') === 'false'; });
    var hidFit = 0, hidOos = 0, shown = 0;
    cards.forEach(function (c) {
      var hide = false;
      if (hideOos && !allOos && c.getAttribute('data-avail') === 'false') { hide = true; hidOos++; }
      else if (fitOn && cardFit(c, b) === 'no') { hide = true; hidFit++; }
      c.classList.toggle('vtb-hide', hide);
      if (!hide) shown++;
    });
    var note = $('#vtb-filter-note'), parts = [];
    if (fitOn) parts.push(hidFit + (hidFit === 1 ? ' part' : ' parts') + ' not listed for MY VTWINBIKE (' + short(b) + ') ' + (hidFit === 1 ? 'is' : 'are') + ' hidden. Parts with no bike listed (like oil or gear) stay shown.');
    if (hideOos && hidOos) parts.push(hidOos + ' sold-out item' + (hidOos === 1 ? ' is' : 's are') + ' hidden.');
    if (allOos) parts.push('Everything here is sold out right now, so we are showing it all.');
    if (shown === 0) parts.push('Nothing on this page matches. ' + (document.querySelector('.pagination') ? 'Try the next page.' : 'Try turning a switch off.'));
    else if ((fitOn || (hideOos && hidOos)) && document.querySelector('.pagination')) parts.push('Use the page numbers below to see more.');
    if (note) { note.textContent = parts.join(' '); note.hidden = !parts.length; }
    var rc = $('.mob-results-count'); if (rc && (fitOn || hideOos)) rc.textContent = shown + ' shown on this page';
  }
  function wireToggles() {
    var fitSw = $('[data-vtb-sw="fit"]'), oosSw = $('[data-vtb-sw="oos"]');
    if (!fitSw && !oosSw) return;
    if (fitSw) {
      setSwitch(fitSw, lsGet(FKEY) === '1' && !!getBike());
      fitSw.addEventListener('click', function () { var on = fitSw.getAttribute('aria-checked') !== 'true'; setSwitch(fitSw, on); lsSet(FKEY, on ? '1' : null); applyFilters(); });
    }
    if (oosSw) {
      setSwitch(oosSw, false);
      oosSw.addEventListener('click', function () { setSwitch(oosSw, oosSw.getAttribute('aria-checked') !== 'true'); applyFilters(); });
    }
    paintToggles(); applyFilters();
  }
  function paintToggles() {
    var b = getBike();
    $$('[data-vtb-fitrow]').forEach(function (row) {
      row.hidden = !b;
      var l = row.querySelector('.vtb-sw__bike'); if (l && b) l.textContent = short(b);
    });
  }
  function onBikeChange() {
    paintChips(); paintToggles();
    var fitSw = $('[data-vtb-sw="fit"]');
    if (fitSw) setSwitch(fitSw, !!getBike() && lsGet(FKEY) === '1');
    applyFilters();
    if (window.VTB_fitRender) { try { window.VTB_fitRender(false); } catch (e) {} }
    paintHome();
  }

  /* boot */
  window.VTB_GARAGE = { route: route, getBike: getBike, mountAll: mountAll, open: function (c, t) { openDlg(c, t); } };
  wireChips();
  mountAll();
  wirePredictive();
  wireSearchBanner();
  wireToggles();
  window.addEventListener('vtb:bike', onBikeChange);
  window.addEventListener('storage', function (e) { if (e.key === KEY || e.key === FKEY) onBikeChange(); });
})();
